const headerElement = document.querySelector('.site-header');
const headerElementInner = headerElement.querySelector('.site-header__inner');
const root = document.documentElement;

document.addEventListener('DOMContentLoaded', function() {
    function updateHeaderHeight() {
        var headerHeight = headerElementInner.offsetHeight;
        root.style.setProperty('--headerheight', `${headerHeight}px`);
    }

    // Initial call to set the header height
    updateHeaderHeight();

    // Recalculate header height on window resize
    window.addEventListener('resize', updateHeaderHeight);


    window.addEventListener('scroll', function() {
        if (window.scrollY > 100) {
            headerElement.classList.add('scrolled');
        } else {
            headerElement.classList.remove('scrolled');
        }
    });

});
